import React from 'react'
import Seat from './Seat'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

const ARC_ANGLE = -0.01

const SEAT_ROTATION = -0.15
export default function SeatGrid({ initialSeats = [], selectedSeats, onSeatClick, sessionUUID, allowClickOnOccupied = false }) {
  const grouped = initialSeats.reduce((acc, seat) => {
    acc[seat.row] = acc[seat.row] || []
    const isSelected = selectedSeats.some((s) => s.id === seat.id)

    acc[seat.row].push({ ...seat, status: isSelected ? 'selected' : seat.status })
    return acc
  }, {})

  return (
    <div>
      {Object.entries(grouped).map(([row, rowSeats]) => {
        const middle = (rowSeats.length - 1) / 2

        return (
          <div key={row} style={rowStyle}>
            <span style={labelStyle}>{row}</span>

            {rowSeats.map((seat, index) => {
              // 👉 espace vide
              if (seat.type === 'empty') {
                return (
                  <Box
                    key={seat.id}
                    sx={{
                      width: { xs: '10px', md: '30px' },
                      height: { xs: '10px', md: '30px' },
                      margin: '5px'
                    }}
                  >
                    {' '}
                  </Box>
                )
              }

              // 👉 siège normal
              // position relative au centre
              const offset = index - middle
              // courbure verticale (effet arc)
              const curve = Math.pow(offset, 2) * ARC_ANGLE
              // rotation légère vers la scène
              const rotation = offset * SEAT_ROTATION

              return (
                <div
                  key={seat.id}
                  style={{
                    transform: ` translateY(${curve}px) rotate(${rotation}deg) `,
                    transition: 'transform 0.2s'
                  }}
                >
                  <Seat
                    seat={seat}
                    sessionUUID={sessionUUID}
                    allowClickOnOccupied={allowClickOnOccupied}
                    onClick={() => onSeatClick(seat)}
                  />
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

const rowStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  marginBottom: '20px'
}

const labelStyle = {
  width: '30px',
  fontWeight: 'bold',
  position: 'relative',
  top: '-12px'
}

SeatGrid.propTypes = {
  initialSeats: PropTypes.array,
  selectedSeats: PropTypes.array.isRequired,
  onSeatClick: PropTypes.func.isRequired,
  sessionUUID: PropTypes.string,
  allowClickOnOccupied: PropTypes.bool
}
